import API from "../api";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async acceptTerm() {
      const { data } = await API.putAcceptTerm();
      return data;
    }
  },
  modules: {}
};
